exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.push([module.id, "@import url(https://db.onlinewebfonts.com/c/20e321b58491fa714e41f835b36b2dce?family=Hera+Big+ExtraLight);", ""]);

// module
exports.push([module.id, "\n.featured-categories-text h2 {\n    font-family: \"Hera Big ExtraLight\";\n}\n", ""]);

// exports
